var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHoursBookingTinCyan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6213 6.06496H0.0319824",
    stroke: "#189477",
    strokeWidth: "1.5px"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6213 11.6636H2.52759",
    stroke: "#189477",
    strokeWidth: "1.5px"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6215 17.9136H3.84351",
    stroke: "#189477",
    strokeWidth: "1.5px"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6214 0.505859V23.4719",
    stroke: "#189477",
    strokeWidth: "1.5px"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6577 6.06496H17.7",
    stroke: "#189477",
    strokeWidth: "1.5px"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6577 11.6636H19.4438",
    stroke: "#189477",
    strokeWidth: "1.5px"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6577 17.9136H23.8676",
    stroke: "#189477",
    strokeWidth: "1.5px"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoursBookingTinCyan);
export default __webpack_public_path__ + "static/media/hours-booking-tin-cyan.15d8ce2692f4aecc84461782a8fd45bf.svg";
export { ForwardRef as ReactComponent };